import { type HTMLAttributes } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium font-body transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-accent-500/20 text-accent-400 border border-accent-500/30',
        secondary: 'bg-white/10 text-slate-300 border border-white/20',
        success: 'bg-success-500/20 text-success-500 border border-success-500/30',
        warning: 'bg-warning-500/20 text-warning-500 border border-warning-500/30',
        error: 'bg-error-500/20 text-error-500 border border-error-500/30',
        outline: 'border border-accent-500 text-accent-400',
        glow: 'bg-accent-500/20 text-accent-400 border border-accent-500/30 shadow-glow',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }


